import {Determinant} from "./determinant";

/**
 * GridComponentDeterminant handles grid-related events (row selection, pagination).
 * This is a field determinant (determinantType = "FORMFIELD") with discriminator "GridComponent".
 *
 * Note: This is different from GridDeterminant which evaluates conditions on rows (ANY/ALL/NONE).
 *
 * Supported grid events:
 * - editGridSelectRow: User selects a row
 * - editGridUnSelectRow: User unselects a row
 * - previousPage: User navigates to previous page
 * - nextPage: User navigates to next page
 */
export class GridComponentDeterminant extends Determinant {

  public gridEventName: string;
  public determinantType = "FORMFIELD";

  /**
   * The grid component key (stored in sourceFormFieldKey in base Determinant)
   */
  public get gridKey(): string {
    return this.sourceFormFieldKey;
  }

  public set gridKey(value: string) {
    this.sourceFormFieldKey = value;
  }

}
